import { render, staticRenderFns } from "./google-map.vue?vue&type=template&id=13060648"
import script from "./google-map.vue?vue&type=script&lang=js"
export * from "./google-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports